<template lang="html">
  <div class="sticky bottom-1 w-100" @click="scrollToTop" v-show="!hidden">
    <div class="back-to-top bg-black pointer user-select-none white
      br-pill pv2 ph3 flex items-center justify-center center
    ">
      <span>Back to top</span>
      <i class="material-icons f5 ml2">&#xE5D8;</i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hidden: true
    };
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset < 50) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    scrollToTop() {
      document.querySelector('html').scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
.back-to-top {
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/BackToTop.vue